import { render } from "./B2bFiltersCoacsuRecibidos.vue?vue&type=template&id=49443c12&scoped=true&lang=pug"
import script from "./B2bFiltersCoacsuRecibidos.vue?vue&type=script&lang=js"
export * from "./B2bFiltersCoacsuRecibidos.vue?vue&type=script&lang=js"

import "./B2bFiltersCoacsuRecibidos.vue?vue&type=style&index=0&id=49443c12&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49443c12"]])

export default __exports__